
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.635 23.248a2.235 2.235 0 01-1.591-.658l-9.5-9.5a2.264 2.264 0 01-.659-1.602c0-.034.003-.067.007-.1L3.438 7.5a.754.754 0 01.847-.639.743.743 0 01.495.291c.121.16.172.357.144.556l-.538 3.829c.01.184.088.362.219.492l9.5 9.5c.142.142.33.219.531.219s.389-.078.53-.219l6.364-6.362a.75.75 0 000-1.06l-9.623-9.626a.752.752 0 00-.509-.219l-3.782.599a.746.746 0 01-.859-.623.75.75 0 01.624-.858l3.838-.608a.779.779 0 01.096-.009l.054-.001c.596 0 1.178.24 1.597.659l9.623 9.626a2.252 2.252 0 010 3.181l-6.363 6.361a2.228 2.228 0 01-1.591.659z"}}),_c('path',{attrs:{"d":"M8.44 10.691a2.252 2.252 0 01-2.03-3.219L.968 2.029c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53a.743.743 0 01.53-.22c.2 0 .389.078.53.22l5.443 5.442a2.252 2.252 0 013.219 2.03 2.252 2.252 0 01-2.25 2.25zm-.538-2.772a.749.749 0 101.288.522.75.75 0 00-1.288-.522zM11.452 12.203a.743.743 0 01-.53-.22c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53l2.121-2.121a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-2.121 2.121a.741.741 0 01-.53.22zM13.573 14.324a.749.749 0 01-.53-1.281l2.122-2.121c.142-.142.33-.219.53-.219s.389.078.53.22a.744.744 0 010 1.06l-2.122 2.121a.747.747 0 01-.53.22zM15.695 16.445a.752.752 0 01-.53-1.281l2.121-2.121a.744.744 0 011.06 0 .752.752 0 010 1.061l-2.121 2.121a.741.741 0 01-.53.22zM13.573 18.567a.743.743 0 01-.53-.22l-4.242-4.243a.744.744 0 010-1.06.744.744 0 011.06 0l4.242 4.243a.75.75 0 01-.53 1.28z"}})])
          )
        }
      }
    